import { Link } from "react-router-dom";
import { PageHeader } from "@/components/data-display/page-header";
import { NotAvailableState } from "@/components/ui/system-state";

// Deferred (ALL-5711; wording DEV-118 / UX audit D09). This route listed authored
// keys from data/mock.ts and minted a client-side "ak_local_mock_..." value that
// authenticated nothing, with create, rotate and revoke acting only on browser
// state. No key lifecycle controller exists yet (context/page_pipeline/BOARD.md,
// developer-api-keys), so the page says where keys come from today and offers the
// way back to the developer console. Nothing here is a key or a credential.
export default function DeveloperApiKeysPage() {
  return (
    <div>
      <PageHeader title="API keys" />
      <NotAvailableState
        title="API keys"
        description="Creating and listing API keys from the console is coming. Until then your Alloy contact issues keys."
      />
      <p className="mt-5 text-center">
        <Link to="/developer" className="text-sm font-semibold text-primary hover:underline">
          Back to developers
        </Link>
      </p>
    </div>
  );
}
